import type { ParsedUrlQuery } from 'querystring';
import { createFilteredQueryStringWithSameOrder } from '../createFilteredQueryStringWithSameOrder';

export const createSearchQueryString = (asPath: string, query: ParsedUrlQuery) => {
  if (!query['nav-q']) {
    return '#';
  }
  const filteredQueryString = createFilteredQueryStringWithSameOrder(asPath);
  return `/s/${query['nav-q']}/${filteredQueryString}`;
};
